<div class="dialog-layer" [class.front]="isFront" [class.interactive]="interactive" [style.zIndex]="200 - stackIndex">

  @if (isFront && !interactive) {
    <div class="overlay"></div>
  }

  <div class="dialog scrollable" [style.transform]="dialogTransform" [style.opacity]="dialogOpacity">

      <div class="header">
          <ng-content select="[header]"></ng-content>
          {{header}}
      </div>

      <div class="content">
          <ng-content select="[content]"></ng-content>
          {{content}}
      </div>

      <div class="actions">
          <div class="actions-pad">
              <ng-content select="[actions]"></ng-content>
          </div>
          @if(content != undefined && !interactive) {
              <div class="actions-pad">
                  <fluent-button (click)="reload()">Reload</fluent-button>
                  <fluent-button (click)="closeApp()">Close App</fluent-button>
              </div>
          }
      </div>

  </div>
</div>